module.exports = __webpack_public_path__ + "img/fan.eec66aab.svg";